import Tabs from "@/components/Tabs";
import { Path } from "@/router";
import { useParams } from "react-router-dom";

export default function TabLayout({ children }: { children: React.ReactNode }) {
  const { pgaId } = useParams();

  if (!pgaId) return null;

  return (
    <>
      <Tabs
        tabItems={[
          { label: "Registrations", link: `/people/${pgaId}/events/registrations` as Path },
          { label: "Cancellations", link: `/people/${pgaId}/events/cancellations` as Path },
          { label: "Participation History", link: `/people/${pgaId}/events/participation-history` as Path }
        ]}
      />
      <div className="flex flex-col" data-testid="tab-content">
        {children}
      </div>
    </>
  );
}
